import React from 'react';
import { connect } from 'react-redux';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Instruktur from '../components/LandingComponent/Instruktur';
import KelasPopuler from '../components/LandingComponent/KelasPopuler';
import Keunggulan from '../components/LandingComponent/Keunggulan';
import LandingBanner from '../components/LandingComponent/LandingBanner';
import RedScreen from '../components/LandingComponent/RedScreen';
import UpcomingCourse from '../components/LandingComponent/UpcomingCourse';
import UpcomingEvent from '../components/LandingComponent/UpcomingEvent';
import LoadingSpinner from '../Layout/LoadingSpinner';
import { removeScript } from '../Utils/Utils';

class CourseDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = async () => {
    if (this.props.refer) {
      this.props.dispatch({
        type: 'UPDATE_LOGINPOPUP_OPEN',
        payload: 1,
      });
      this.props.dispatch({
        type: 'UPDATE_REGISTERPOPUP_OPEN',
        payload: 1,
      });
    }
  };

  componentWillUnmount() {
    removeScript('https://app.sandbox.midtrans.com/snap/snap.js');
  }

  render() {
    return (
      <>
        <Header />
        <div className="main-container container d-flex flex-column">
          <LandingBanner />
          <Keunggulan />
          <KelasPopuler landing={true} />
          <UpcomingCourse />
          <RedScreen />
          <UpcomingEvent />
          <Instruktur />
        </div>
        <Footer />
        {this.props.isLoading ? <LoadingSpinner text={'Mohon menunggu..'} /> : ''}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { isLoading: state.isLoading };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetail);
